export default "__VITE_ASSET__DT8Gefc2__"